import { ElementType } from 'react';
import CarouselLayer from '../layers/CarouselLayer';
import FrameLayer from '../layers/FrameLayer';
import GroupLayer from '../layers/GroupLayer';
import ImageLayer from '../layers/ImageLayer';
import LineLayer from '../layers/LineLayer';
import RootLayer from '../layers/RootLayer';
import ShapeLayer from '../layers/ShapeLayer';
import SvgLayer from '../layers/SvgLayer';
import TextLayer from '../layers/TextLayer';
import VideoLayer from '../layers/VideoLayer';

export const resolvers: Record<string, ElementType> = {
  RootLayer,
  CarouselLayer,
  ShapeLayer,
  TextLayer,
  ImageLayer,
  GroupLayer,
  FrameLayer,
  SvgLayer,
  LineLayer,
  VideoLayer,
};
